import * as React from 'react';

function SvgComponent({ isSelected, ...props }) {
    return (
        <svg
            width={46}
            height={38}
            viewBox="0 0 46 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect x={0.5} y={0.5} width={45} height={37} rx={5.5} fill="#fff" />
            <rect
                x={0.5}
                y={0.5}
                width={45}
                height={37}
                rx={5.5}
                stroke={isSelected ? '#2C87F3' : '#999'}
            />
            <path transform="translate(8 10)" fill="#313131" d="M0 0H23V1H0z" />
            <path
                transform="translate(8 15)"
                fill={isSelected ? '#2C87F3' : '#999'}
                d="M0 0H30V8H0z"
            />
            <path transform="translate(8 27)" fill="#313131" d="M0 0H15V1H0z" />
        </svg>
    );
}

export default SvgComponent;
